import { AfterViewInit, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Store } from '@ngxs/store';
import { AppIcons, AppStoreActions, ComparadorService, UserGeolocationService } from '@app/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'ClientApp';

  constructor(
    breakpointObserver: BreakpointObserver,
    private store: Store,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private comparadorService: ComparadorService,
    private userGeolocationService: UserGeolocationService,
    @Inject(DOCUMENT) private document,
    private elementRef: ElementRef,
    private router: Router
  ) {
    this.subscribeToBreakpoint(breakpointObserver);
    this.registerIcons();
    this.comparadorService.loadUniversidadesFromLocalStorage();
    this.comparadorService.loadCarrerasFromLocalStorage();
    this.userGeolocationService.loadGeoLocationFromLocalStorage();
  }

  ngOnInit(): void {
    this.subscribeToRouter();
  }

  ngAfterViewInit() {
    this.loadGoogleMapsScript();
    this.loadAnalytics();
  }

  private subscribeToRouter = () => {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        gtag("js", new Date());
        gtag("config", environment.keys.GA_CODE, {
          page_path: event.urlAfterRedirects,
          //cookie_flags: 'max-age=7200;secure;samesite=strict'
        });
      }
    });
  };

  private subscribeToBreakpoint = (breakpointObserver: BreakpointObserver) => {
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      //if (result.matches) {
      //this.activateHandsetLayout();
      this.store.dispatch(new AppStoreActions.Ui.SetMobileLayout({ isMobile: result.matches }));
      //}
    });
  }

  private registerIcons = () => {
    AppIcons.forEach(item => {
      this.matIconRegistry.addSvgIcon(
        item.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(item.path)
      );
    });
  }

  private loadGoogleMapsScript = () => {
    let s = this.document.createElement("script");
    s.type = "text/javascript";
    s.src = `${environment.urls.GOOGLE_MAPS_API}${environment.keys.GOOGLE_MAPS_API}`;
    this.elementRef.nativeElement.appendChild(s);
  }

  private loadAnalytics = () => {

    const s = this.document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${environment.keys.GA_CODE}`;
    this.elementRef.nativeElement.appendChild(s);

    let gaScript2 = this.document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}`;

    this.elementRef.nativeElement.appendChild(gaScript2);
  }
}

@Component({
  template: `<app-layout><router-outlet></router-outlet></app-layout>`,
  styles: ['']
})
export class ModulesContainerComponent {

  constructor(
    private router: Router,
  ) {

  }

  ngOnInit(): void {
  }

}
